import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { organizationActions, periodsActions, currencyActions } from '../../redux/actions/';
import { Button, Col, Row, Dropdown, Space, Modal, List }  from 'antd';
import { DownOutlined, WarningOutlined } from '@ant-design/icons';
import { currencyConstants } from '../../redux/constants';
import CurrencyTable from '../../components/CurrencyTable';
import RenderUpdater from '../../components/RenderUpdater';
import OverlayedLoader from '../../components/OverlayedLoader';

const Currency = () => {
    const dispatch = useDispatch();
    const fetchingExpandedPeriods = useSelector((state) => state.periods.fetchingExpandedPeriods);

    const currencies = useSelector((state) => state.currency.currency);
    const organization = useSelector((state) => state.organization.organization);
    const periods = useSelector((state) => state.periods.periods);
    const expandedPeriods = useSelector((state) => state.periods.expandedPeriods);

    const creatingCurrency = useSelector((state) => state.currency.creatingCurrency);
    const updatingCurrency = useSelector((state) => state.currency.updatingCurrency);
    const deletingCurrency = useSelector((state) => state.currency.deletingCurrency);

    const updatingOrganization = useSelector((state) => state.organization.updatingOrganization);
    const updatingBaseCurrency = useSelector((state) => state.organization.updatingBaseCurrency);

    const deleteCurrencyBlockedBy = useSelector((state) => state.currency.deleteCurrencyBlockedBy);

    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [selectedRowKey, setSelectedRowKey] = useState([]);
  

    useEffect(() => {
        dispatch(organizationActions.getOrganization());
        dispatch(periodsActions.getPeriods());
        dispatch(currencyActions.getCurrency());
    }, [dispatch]);

    useEffect(() => {
        if (expandedPeriods == null) {
            if (!fetchingExpandedPeriods) dispatch(periodsActions.getExpandedPeriods());
        }
    }, [dispatch, fetchingExpandedPeriods, expandedPeriods]);

    const items =
    currencies?.map((currency) => ({
        label: currency.currency,
        key: currency.currency_id,
    })) || [];
    
    const baseCurrency =
    currencies?.find(
        (currency) => currency.currency_id === organization?.base_currency
    )?.currency || 'Select group currency';

    const handleCreateCurrency = () => {
        if (!creatingCurrency) dispatch(currencyActions.createCurrency());
    };

    const handleUpdateCurrency = (currency) => {
        if (!updatingCurrency) dispatch(currencyActions.updateCurrency(currency));
    };

    const handleDeleteCurrency = () => {
        if (!deletingCurrency) dispatch(currencyActions.deleteCurrency(selectedCurrency));
    };

    const handleSetSelectedCurrency = (selectedCurrency) => {
        setSelectedCurrency(selectedCurrency);
    };

    const handleUpdateBaseCurrencyOnOrganization = (e) => {
        const newBaseCurrencyId = e.key;
        if (!updatingBaseCurrency) dispatch(organizationActions.updateBaseCurrency(newBaseCurrencyId));
    };

    const handleCloseBlockedModal = () => {
        dispatch({ type: currencyConstants.DELETE_CURRENCY_BLOCKED, scenarios: null });
    };

    const baseCurrencyMenuProps = {
        items,
        onClick: handleUpdateBaseCurrencyOnOrganization,
    };

    const renderContent = () => {
        if (organization == null) return <OverlayedLoader />;
        if (currencies == null) return <OverlayedLoader />;
        if (periods == null) return <OverlayedLoader />;
        if (expandedPeriods == null) return <OverlayedLoader />;
        if (updatingOrganization) return <RenderUpdater />;

        return (
            <div className="">
                <Row
                    style={{
                        marginBottom: 20,
                    }}
                >
                    <Col span={8}>
                    <div
                        style={{
                            marginTop: '20px',
                            marginLeft: '25px',
                        }}
                    >
                        <div
                            style={{
                                marginBottom: '8px',
                                fontWeight: 500,
                            }}
                        >
                            Group currency
                        </div>
                        <div
                            style={{
                                marginBottom: '8px',
                                fontSize: '12px',
                                color: '#666',
                            }}
                        >
                             Used for consolidation and reporting.
                        </div>

                        <Dropdown menu={baseCurrencyMenuProps}>
                            <Button
                                style={{
                                    minWidth: '180px',
                                }}
                            >
                                <Space>
                                    {baseCurrency}
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>
                    </div>
                </Col>
                </Row>
                <CurrencyTable
                    currency={currencies}
                    organization={organization}
                    periods={periods}
                    expandedPeriods={expandedPeriods}
                    selectedRowKey={selectedRowKey}
                    setSelectedRowKey={setSelectedRowKey}
                    handleUpdateCurrency={handleUpdateCurrency}
                    handleSetSelectedCurrency={handleSetSelectedCurrency}
                />
                <Button
                    type="primary"
                    style={{
                        float: 'right',
                        marginRight: '0',
                        marginTop: '10px',
                    }}
                    onClick={() => {
                        handleDeleteCurrency();
                    }}
                >
                    Delete currency
                </Button>
                <Button
                    type="primary"
                    style={{
                        float: 'right',
                        marginRight: '15px',
                        marginTop: '10px',
                    }}
                    onClick={() => {
                        handleCreateCurrency();
                    }}
                >
                    Add currency
                </Button>

                   <Modal
                    open={deleteCurrencyBlockedBy !== null && deleteCurrencyBlockedBy !== undefined}
                    onCancel={handleCloseBlockedModal}
                    footer={
                        <Button type="primary" onClick={handleCloseBlockedModal}>
                            OK
                        </Button>
                    }
                    title={
                        <Space>
                            <WarningOutlined style={{ color: '#faad14' }} />
                            Cannot delete currency
                        </Space>
                    }
                >
                    <p>
                        This currency is used as the local currency in the following scenarios.
                        Please delete these scenarios before removing the currency:
                    </p>
                    <List
                        size="small"
                        bordered
                        dataSource={deleteCurrencyBlockedBy ?? []}
                        renderItem={(scenario) => (
                            <List.Item>{scenario.name}</List.Item>
                        )}
                    />
                </Modal>

            </div>
        );
};
    return renderContent();
};

export default Currency;
